import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'

const ZetLogo = ({ ...props }) => (
  <Svg
    width={75}
    height={30}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <G clipPath="url(#a)" fill="#596379">
      <Path d="M75 0H42.662l4.155 9.268h9.567v20.836h9.131V9.268H75V0ZM26.111 0H0v9.268h12.592L0 20.836v9.268h26.111v-9.268H13.52L26.111 9.268V0ZM49.873 20.836h-13.31V19.24h12.57l-2.373-5.214-1.447-3.162h-8.75V9.268h7.941L40.346 0H28.2V30.104H54.11l-4.237-9.268Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h75v30H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default ZetLogo
